import type { CurrentUser } from "./types";

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    public readonly code?: string,
  ) {
    super(message);
  }
}

let csrfToken = "";

export function setCsrfToken(token?: string) {
  csrfToken = token ?? "";
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (
    init.body &&
    !headers.has("Content-Type") &&
    !(init.body instanceof FormData)
  )
    headers.set("Content-Type", "application/json");
  if (
    ["POST", "PUT", "PATCH", "DELETE"].includes(init.method ?? "GET") &&
    csrfToken
  )
    headers.set("X-CSRF-Token", csrfToken);
  const response = await fetch(`/api${path}`, {
    credentials: "include",
    ...init,
    headers,
  });
  if (!response.ok) {
    const payload = (await response.json().catch(() => ({}))) as {
      error?: { message?: string; code?: string };
    };
    throw new ApiError(
      response.status,
      payload.error?.message ?? "Không thể kết nối máy chủ.",
      payload.error?.code,
    );
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}

export async function loadCurrentUser(): Promise<CurrentUser> {
  const result = await api<{ user: CurrentUser; csrfToken: string }>("/me");
  setCsrfToken(result.csrfToken);
  return { ...result.user, csrfToken: result.csrfToken };
}

export function json(body: unknown): RequestInit {
  return { method: "POST", body: JSON.stringify(body) };
}
